export default __webpack_public_path__ + "static/media/ep_18.0c2da6a8.png";